export default "__VITE_ASSET__aad74534__"